import { useMemberExtract } from 'contexts/MemberExtract';
import React from 'react';
import Row from './Row';
import ShowMore from './ShowMore';

function Table() {
  const { memberExtract } = useMemberExtract();

  const extracts = memberExtract.memberExtractList;

  return (
    <div className="corporate-club-extract__card__body__table">
      <div className="corporate-club-extract__card__body__table__rows">
        {extracts.map((extract) => (
          <Row key={extract.id} extract={extract} />
        ))}
      </div>
      <ShowMore />
    </div>
  );
}

export default Table;
